import axios from "axios";

// 登录请求方法
const loginreq = (method, url, params) => {
  let text = "";
  let a = 0;
  for (const key in params) {
    if (a == 0) {
      text = text + key + "=" + params[key];
    } else {
      text = text + "&" + key + "=" + params[key];
    }
    a++;
  }

  return axios({
    method: method,
    // url: "http://dljc.youkutongcheng.com"+url+"?"+text,
    // url: "http://dljc.youkutongcheng.com"+url+"?"+text,
    url: "http://118.195.249.109:446" + url + "?" + text,
     //url: "http://118.195.249.109:446" + url + "?" + text,
    ders: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      }
    ]
  }).then(res => {
    if (res.data.code == 422) {
      localStorage.clear()
      location.reload()
    } else {
      return res.data
    }
  });
};

// 通用公用方法
const req = (method, url, params) => {
  // let text = "";
  // let a = 0;
  // for (const key in params) {

  //   if(a==0){
  //     text =text+ key+"="+params[key]
  //   }else{
  //     text =text+ "&"+key+"="+params[key]
  //   }
  //   a++;
  // }
  console.log("data=========", params);
  return axios({
    method: method,

    url: "http://118.195.249.109:446" + url + "?" + "&token=" + localStorage.getItem('logintoken'),

    // url:
    //   "http://118.195.249.109:446" +
    //   url +
    //   "?" +
    //   "&token=" +
    //   localStorage.getItem("logintoken"),

    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      token: localStorage.getItem("logintoken")
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }

        return ret;
      }
    ]
  }).then(res => {
    if (res.data.code == 422) {
      localStorage.clear()
      location.reload()
    } else {
      return res.data
    }
  });
};

export { loginreq, req };



// WEBPACK FOOTER //
// ./src/api/axiosFun.js